"use client";

import ReactMarkdown, { type Components } from "react-markdown";
import { PORTAL_MARKDOWN_ELEMENTS as E } from "./portalMarkdownStyles";

// Headings step down one level: a brief's `#` is a section inside the portal
// page, whose own title is the h1.
const components: Partial<Components> = {
  h1: ({ children }) => <h2 className={E.h1}>{children}</h2>,
  h2: ({ children }) => <h3 className={E.h2}>{children}</h3>,
  h3: ({ children }) => <h4 className={E.h3}>{children}</h4>,
  p: ({ children }) => <p className={E.p}>{children}</p>,
  ul: ({ children }) => <ul className={E.ul}>{children}</ul>,
  ol: ({ children }) => <ol className={E.ol}>{children}</ol>,
  li: ({ children }) => <li>{children}</li>,
  strong: ({ children }) => <strong className={E.strong}>{children}</strong>,
  blockquote: ({ children }) => (
    <blockquote className={E.blockquote}>{children}</blockquote>
  ),
  code: ({ children }) => <code className={E.code}>{children}</code>,
  a: ({ children, href }) => (
    <a href={href} target="_blank" rel="noreferrer" className={E.a}>
      {children}
    </a>
  ),
};

export function PortalMarkdown({ children }: { children: string }) {
  return <ReactMarkdown components={components}>{children}</ReactMarkdown>;
}
